// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// require("@rails/ujs").start()
// require("@rails/activestorage").start()
// require("channels")

import { createApp, h } from "vue";

import * as Routes from "../packs/routes";
import axios from "axios";
import StringManipulation from "../Mixins/StringManipulation";
import Utils from "../Mixins/Utils";
import InfoIcon from "../Shared/InfoIcon.vue";
import WarningIcon from "../Shared/WarningIcon.vue";

axios.defaults.xsrfHeaderName = "X-CSRF-Token";
const el = document.getElementById("app");

//New
import "@fortawesome/fontawesome-free/css/all.css";
import { router, createInertiaApp } from "@inertiajs/vue3";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, fa } from "vuetify/iconsets/fa";
import { mdi } from "vuetify/iconsets/mdi";
import Notifier from "@/plugins/notifier";
// Register all Chart.js components/plugins once for the whole app.
import "@/Charts/base/registerChartjs";

const pages = import.meta.glob("../Pages/**/*.vue", { eager: true });

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "fa",
    aliases,
    sets: { fa, mdi },
  },
});

createInertiaApp({
  resolve: (name) => {
    const component = pages[`../Pages/${name}.vue`];
    if (!component)
      throw new Error(
        `Unknown page ${name}. Is it located under Pages with a .vue extension?`
      );

    return component;
  },

  title: (title) => (title ? `${title} - Ping CRM` : "Ping CRM"),

  setup({ el, App, props, plugin }) {
    const vueApp = createApp({
      render: () => h(App, props),
    });
    vueApp.config.globalProperties.$routes = Routes;
    vueApp.use(plugin).use(vuetify).use(Notifier).mount(el);
  },
});
